import type { PublicSlotKey } from '#packages/apilib';
import type { DebugLayoutPublicApi } from './api';

export const DebugLayoutApiKey: PublicSlotKey<DebugLayoutPublicApi> = {
  name: 'DebugLayoutApi',
  public: true,
};
